import PropTypes from "prop-types";
import { Box } from "@mui/material";

import { useScreen } from "hooks";

import HorizontalArrows from "./components/HorizotalArrows";
import VerticalArrows from "./components/VerticalArrows";

const ScrollArrows = ({ children, scrollContainerWidth }) => {
  const { isTablet, isDesktop } = useScreen();
  const getDuration = (scrollDistanceInPx) => scrollDistanceInPx * 1;

  if (isTablet)
    return (
      <HorizontalArrows scrollContainerWidth={scrollContainerWidth} getDuration={getDuration}>
        {children}
      </HorizontalArrows>
    );
  if (isDesktop)
    return (
      <Box display="flex" justifyContent="center" wrap="nowrap" mt={2}>
        {children}
        <VerticalArrows getDuration={getDuration} />
      </Box>
    );

  return children;
};

ScrollArrows.propTypes = {
  scrollContainerWidth: PropTypes.number.isRequired,
};

export default ScrollArrows;
